import * as urlUtils from 'utils/Url';


//======================================
// Partners
//======================================
export function getPathControlPartners(qs={}) {
  return urlUtils.appendQueryString(`/control/partners`, qs);
}

export function getPathControlPartnerCommissions(affiliateId, qs={}) {
  return urlUtils.appendQueryString(`/control/partners/${affiliateId}/commissions`, qs);
}

export function getPathControlReferrals(qs={}) {
  return urlUtils.appendQueryString(`/control/referrals`, qs);
}

export function getPathControlPartnerPayouts(qs={}) {
  return urlUtils.appendQueryString(`/control/partner-payouts`, qs);
}

//======================================
// Agencies
//======================================
export function getPathControlAgencies(qs={}) {
  return urlUtils.appendQueryString(`/control/agencies`, qs);
}

export function getPathControlAgencyOptions(qs={}) {
  return urlUtils.appendQueryString(`/control/agency-options`, qs);
}

export function getPathControlPrevewAgencyDetails(agencyId) {
  return `/control/agencies/${agencyId}/preview-details`;
}


//======================================
// Integration Partner
//======================================
export function getPathControlIntegrationPartners(qs={}) {
  return urlUtils.appendQueryString(`/control/integration-partners`, qs);
}

export function getPathControlAddIntegrationPartner() {
  return `/control/integration-partners/add`;
}

export function getPathControlEditIntegrationPartner(integrationId) {
  return `/control/integration-partners/${integrationId}/edit`;
}

export function getPathControlIntegrationPartnerOptions(qs={}) {
  return urlUtils.appendQueryString(`/control/integration-partner-options`, qs);
}


//======================================
// Partner Deal
//======================================
export function getPathControlPartnerDeals(qs={}) {
  return urlUtils.appendQueryString(`/control/partner-deals`, qs);
}

export function getPathControlAddPartnerDeal() {
  return `/control/partner-deals/add`;
}

export function getPathControlEditPartnerDeal(dealId) {
  return `/control/partner-deals/${dealId}/edit`;
}
